import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>SEDG Cell</h1>
                <p>Home &gt; SEDG Cell</p>
            </div>
        </div>
    )
}

export default Hero;